import cloneDeep from 'lodash/cloneDeep'

export const fromPipelineDetails = (pipelineDetails, categories, lastStageOrderIndex) => {
  const category = pipelineDetails.category.value
    ? categories.find(category => category.id === pipelineDetails.category.value)
    : pipelineDetails.category
  return {
    code: pipelineDetails.name,
    name: pipelineDetails.label,
    category,
    color: pipelineDetails.color,
    orderIndex: pipelineDetails.orderIndex || lastStageOrderIndex + 1,
    id: pipelineDetails.id,
    visibleOnBoardLanes: pipelineDetails.visibleOnBoardLanes
  }
}

export const toCategories = categories =>
  categories.map(category => ({
    value: category.id,
    label: category.name
  }))

export const toPipelineStage = stage => ({ ...stage, name: stage.code, label: stage.name })

export const toPipelineStages = (stages, serializeStage = true) => {
  stages.sort((a, b) => a.orderIndex - b.orderIndex)
  const firstIndex = stages[0].orderIndex
  const lastIndex = stages[stages.length - 1].orderIndex
  return stages.map(stage => ({
    ...(serializeStage ? toPipelineStage(stage) : stage),
    isFirst: stage.orderIndex === firstIndex,
    isLast: stage.orderIndex === lastIndex
  }))
}

export const toDealStatusSelect = (stages, stage) => {
  const clonedStages = cloneDeep(stages)
  const index = clonedStages.findIndex(s => s.code === stage)
  clonedStages.splice(index, 1)
  return clonedStages.map(s => ({ value: s.name, label: s.label }))
}

export const fromDealsData = deals =>
  deals.map(d => ({
    name: d.name,
    id: d.id,
    status: d.status.code
  }))
